import {
  SourceDetails as EdgeSourceDetails,
  useListSourceDetailsQuery,
} from 'generated/graphql';
import { useMemo } from 'react';
import { SourceDetail } from 'v2/core/entities/feedback/sources';
import { SourceName } from 'v2/core/entities/fields';
import { getSourceWithNamespaceFromEdgeSource } from 'v2/core/repository/edge-server/sourceMapper';
import { apolloStatusToQueryStatus } from 'v2/core/repository/edge-server/statusConvertor';
import {
  EdgeResponse,
  QueryOptions,
  QueryStatus,
} from 'v2/core/repository/edge-server/types';

const toSourceDetails = (source: EdgeSourceDetails): SourceDetail => ({
  name: getSourceWithNamespaceFromEdgeSource(source.id),
  eqlValue: source.eqlValue,
});

const useGetSourceDetailsMap = (
  options?: QueryOptions,
): EdgeResponse<Map<SourceName, SourceDetail>> => {
  const { data, loading, error, called } = useListSourceDetailsQuery({
    fetchPolicy: options?.FetchPolicy,
    skip: options?.Skip,
  });

  const status = apolloStatusToQueryStatus(loading, called, false, error);

  const detailsMap = useMemo(() => {
    if (!!data) {
      return new Map(
        data?.listSourceDetails?.sources?.map((source) => {
          const detail = toSourceDetails(source);
          return [detail.name.name, detail];
        }),
      );
    }

    return undefined;
  }, [data]);

  return {
    status,
    error,
    data: status === QueryStatus.SUCCESS_COMPLETED ? detailsMap : undefined,
  };
};

export default useGetSourceDetailsMap;
